import { z } from 'zod';
import { mediaEntityType } from 'data/enums/media-entity-type';

export const LearningContentMediaQuerySchema = z.object({
  entityId: z.string().uuid(),
  type: z.enum(Object.values(mediaEntityType)),
});

export type LearningContentMediaQuery = z.infer<typeof LearningContentMediaQuerySchema>;
